/**
 * @generated SignedSource<<107ef762d79f677fc5ae0dfb3f35d744>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_item$data = {
  readonly pdpURL: string | null;
  readonly saveSearchData: {
    readonly name: string | null;
    readonly page: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedAuctionButtons_item" | "PdpSharedContactDealerButton_item" | "PdpSharedDeposit_item" | "PdpSharedMakeOfferButton_item" | "PdpSharedPurchaseButton_item">;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_item";
};
export type PdpSharedCondensedSidebarButtons_item$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDeposit_item"
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedCondensedAuctionButtons_item"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SaveSearchDataType",
      "kind": "LinkedField",
      "name": "saveSearchData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "page",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d55f27e4b91d80056e283012653843ab";

export default node;
